// extracted by mini-css-extract-plugin
export default {"device-management-container":"DeviceManagement_device-management-container__8tVeR","device-management-header":"DeviceManagement_device-management-header__XGuN8"};